/* PW v95.2 (16 Oct): "N days until Christmas" countdown for the homepage strip and announcement line
   (snippets/pw-holiday-cutoff, Christmas season). Counts to midnight on Dec 25 in the shopper's own time zone.
   [data-pw-xmas-until] gets a DAYS / HRS / MIN board built with the split-flap classes from assets/pw-motion.js
   (static digits, updated every 20s); [data-pw-xmas-days] gets the "N days" text. */
(function () {
  function target(ymd) { var p = String(ymd).split('-').map(Number); return new Date(p[0], p[1] - 1, p[2], 0, 0, 0).getTime(); }
  function cell() {
    var c = document.createElement('i'); c.className = 'pw-flap__c'; c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<i class="pw-flap__h t"><i></i></i><i class="pw-flap__h b"><i></i></i><i class="pw-flap__h ft"><i></i></i><i class="pw-flap__h fb"><i></i></i>';
    return c;
  }
  function setc(c, ch) { [].forEach.call(c.querySelectorAll('.pw-flap__h > i'), function (n) { n.textContent = ch; }); }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var boards = [], days = [];
  function tick() {
    var now = Date.now();
    boards.forEach(function (o) {
      var s = Math.max(0, Math.floor((o.t - now) / 1000)), d = Math.min(99, Math.floor(s / 86400)), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      var str = pad(d) + pad(h) + pad(m);
      o.cells.forEach(function (c, i) { setc(c, str[i]); });
      if (s <= 0) { var w = o.h.closest('[data-pw-hc-until]'); if (w) w.hidden = true; }
    });
    days.forEach(function (o) {
      var d = Math.max(0, Math.ceil((o.t - now) / 86400000));
      o.el.textContent = d + (d === 1 ? ' day' : ' days');
    });
  }
  function init() {
    [].forEach.call(document.querySelectorAll('[data-pw-xmas-until]'), function (h) {
      if (h.__pw952) return; h.__pw952 = 1;
      h.className = 'pw-flapb pw-flapb--strip pw-flapb--xmas'; h.textContent = '';
      var cells = [];
      ['DAYS', 'HRS', 'MIN'].forEach(function (u) {
        var w = document.createElement('i'); w.className = 'pw-flapb__u';
        var row = document.createElement('i'); row.className = 'pw-flapb__d';
        var c1 = cell(), c2 = cell(); row.appendChild(c1); row.appendChild(c2); cells.push(c1, c2);
        var lb = document.createElement('i'); lb.className = 'pw-flapb__l'; lb.textContent = u;
        w.appendChild(row); w.appendChild(lb); h.appendChild(w);
      });
      boards.push({ h: h, t: target(h.getAttribute('data-pw-xmas-until')), cells: cells });
    });
    [].forEach.call(document.querySelectorAll('[data-pw-xmas-days]'), function (el) {
      if (el.__pw952) return; el.__pw952 = 1;
      days.push({ el: el, t: target(el.getAttribute('data-pw-xmas-days')) });
    });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(function () { if (!document.hidden) tick(); }, 20000);
})();
